import { FavoritableType, Favorite } from 'api/clients/FavoriteClient'
import { find } from 'lodash'
import { FileType } from 'types'

export const fileTypeToFavoritableType = (fileType: FileType) => {
  switch (fileType) {
    case 'folder':
      return FavoritableType.Project
    case 'handbook':
      return FavoritableType.Handbook
    case 'article':
    default:
      return FavoritableType.Article
  }
}

export const findFavorite = ({
  fileId,
  fileType,
  favorites,
}: {
  fileId: string
  fileType: FileType
  favorites: Favorite[]
}) => {
  const type = fileTypeToFavoritableType(fileType)
  return find(favorites, { favoritable_id: fileId, favoritable_type: type }) as Favorite | undefined
}
